jQuery(document).ready(function ($) {
  //##################################################//
  //###*****   Mobile search input button    *****###//
  //#################################################//

  const mqc = window.matchMedia('(max-width: 991px)');
  if (mqc.matches) {
    $('.js-site-header__search').click(function () {
      //console.log('clicked');
      $(this).find('.c-site-header__search-form').addClass('is-active');
    });
  }

  if ($('.prefix-cart-cost-centres').length) {
    var verifytest = true;

    // remove cart button links

    $('.cart-checkout-button a')
      .removeAttr('href')
      .addClass('verify-cost-centres');

    // run onlclick action to verify cost centre have been inputted

    $(document).on('click', '.wc-proceed-to-checkout a', function () {
      $('.wc-proceed-to-checkout a').removeAttr('href');
      $('.prefix-cart-cost-centres').each(function (index) {
        if (this.value == '') {
          verifytest = false;
          $('.woocommerce-notices-wrapper').html(
            '<div class="woocommerce-error" role="alert">Cost centres have not been selected for all the basket items.</div>'
          );
          return false;
        } else {
          verifytest = true;
        }
      });

      // we are good to go :)

      if (verifytest == true) {
        $('.woocommerce-notices-wrapper').html('');
        window.location.href = '/checkout';
      }
    });
  }
});
